/**
 * Internal dependencies
 */
import { isEditedLayoutDirty } from 'state/dashboard-layouts/selectors';
import getLayoutId from './get-layout-id';

export default (state) => isEditedLayoutDirty(state, getLayoutId(state));
